// extracted by mini-css-extract-plugin
export var chevron = "_i5-4";
export var chevronExpanded = "_i5-5";
export var row = "_i5-0";
export var rowBody = "_i5-6";
export var rowDescription = "_i5-7";
export var rowHeader = "_i5-1";
export var rowTitle = "_i5-2";
export var rowTitleComplete = "_i5-3";